module.exports = __webpack_public_path__ + "media/store/images/instagram-465f506e0470058ace6fe258f139e979.svg";